export default "__VITE_ASSET__D2G8QSJB__"